<div class="main-content table-page table-page--compact table-page--dense modalidades-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Modalidades</h1>
        <p>Dónde se espera a cada persona; sin modalidad asignada, el día no se evalúa.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="verSoloSinAsignar()">
          <span class="material-icons">person_search</span>
          Ver sin asignar
        </button>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Nombre o usuario</mat-label>
              <input matInput aria-label="Nombre o usuario" [(ngModel)]="filtroBusqueda" (keyup.enter)="consultaPagina(1)" />
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Modalidad</mat-label>
              <mat-select [(ngModel)]="filtroModalidad" (selectionChange)="consultaPagina(1)">
                <mat-option [value]="null">Todas</mat-option>
                <mat-option value="OFICINA">En sitio</mat-option>
                <mat-option value="HOME_OFFICE">Desde casa</mat-option>
                <mat-option value="MIXTO">Mixto</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Sitio</mat-label>
              <mat-select [(ngModel)]="filtroUbicacion" (selectionChange)="consultaPagina(1)">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let sitio of ubicaciones" [value]="sitio.id">
                  {{ sitio.nombre }}<span *ngIf="sitio.nombreCliente"> · {{ sitio.nombreCliente }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Asignación</mat-label>
              <mat-select [(ngModel)]="filtroSinAsignar" (selectionChange)="consultaPagina(1)">
                <mat-option [value]="false">Toda la plantilla</mat-option>
                <mat-option [value]="true">Solo sin asignar</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  (click)="limpiarFiltros()">
            <span class="material-icons">filter_alt_off</span>
            Limpiar
          </button>
          <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="consultaPagina(1)">
            <span class="material-icons">search</span>
            Consultar
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap" *ngIf="renglones.length > 0; else modalidadesEmptyState">
        <table class="table-page__table">
          <thead>
            <tr>
              <th>Persona</th>
              <th>Modalidad</th>
              <th>Dónde se le espera</th>
              <th>Vigencia</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let renglon of renglones">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ renglon.nombreEmpleado }}</strong>
                  <span class="table-page__subtext">{{ renglon.usuario }}</span>
                </div>
              </td>
              <td><span [class]="claseModalidad(renglon)">{{ etiquetaModalidad(renglon) }}</span></td>
              <td><span class="table-page__text">{{ etiquetaSitio(renglon) }}</span></td>
              <td><span class="table-page__text">{{ etiquetaVigencia(renglon) }}</span></td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn"
                        [title]="renglon.modalidad ? 'Cambiar modalidad' : 'Asignar modalidad'"
                        [attr.aria-label]="renglon.modalidad ? 'Cambiar modalidad' : 'Asignar modalidad'"
                        (click)="asignar(renglon)">
                  <span class="material-icons">edit_calendar</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #modalidadesEmptyState>
        <div class="table-page__empty" *ngIf="!loading; else modalidadesLoadingState">
          <span class="material-icons">badge</span>
          <h3>No hay personas que mostrar</h3>
          <p>Con estos filtros no sale nadie. Si acaba de desplegar el módulo, quite el filtro y verá la plantilla completa.</p>
        </div>
      </ng-template>

      <ng-template #modalidadesLoadingState>
        <div class="table-page__empty table-page__empty--loading">
          <span class="material-icons">hourglass_top</span>
          <h3>Consultando la plantilla</h3>
          <p>Espere un momento.</p>
        </div>
      </ng-template>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          Mostrando {{ (currentPage - 1) * pageSize + 1 }} a {{ rangeEnd }} de {{ totalRegistros }}
        </div>
        <nav class="table-page__pager" aria-label="Paginación">
          <button type="button" class="table-page__pager-link" title="Primera página" aria-label="Primera página"
                  [disabled]="currentPage === 1" (click)="firstPage()">
            <span class="material-icons">first_page</span>
          </button>
          <button type="button" class="table-page__pager-link" title="Página anterior" aria-label="Página anterior"
                  [disabled]="currentPage === 1" (click)="previousPage()">
            <span class="material-icons">chevron_left</span>
          </button>
          <ng-container *ngFor="let item of getPaginationItems()">
            <button type="button" class="table-page__pager-page"
                    [class.is-current]="item === currentPage"
                    *ngIf="isPageNumber(item); else puntosSuspensivos"
                    (click)="onPageChange(+item)">
              {{ item }}
            </button>
            <ng-template #puntosSuspensivos><span class="table-page__pager-ellipsis">…</span></ng-template>
          </ng-container>
          <button type="button" class="table-page__pager-link" title="Página siguiente" aria-label="Página siguiente"
                  [disabled]="currentPage === totalPages" (click)="nextPage()">
            <span class="material-icons">chevron_right</span>
          </button>
          <button type="button" class="table-page__pager-link" title="Última página" aria-label="Última página"
                  [disabled]="currentPage === totalPages" (click)="lastPage()">
            <span class="material-icons">last_page</span>
          </button>
        </nav>
        <div class="table-page__page-size">
          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Por página</mat-label>
            <mat-select [(ngModel)]="pageSize" (selectionChange)="onPageSizeChange(pageSize)">
              <mat-option *ngFor="let tamano of pageSizeOptions" [value]="tamano">{{ tamano }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </section>
  </div>
</div>
